import { Editor } from '@tiptap/react';
import React, { FC, PropsWithChildren, useCallback, useRef } from 'react';

import { ToolbarButton } from '../../ToolbarButton';

export const ImageToolbarButton: FC<
  { editor: Editor; uploadService: (file: File) => Promise<string> } & PropsWithChildren
> = ({ editor, uploadService, children }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const onClick = useCallback(() => {
    inputRef.current?.click();
  }, []);
  const onSelectFile: React.ChangeEventHandler<HTMLInputElement> = useCallback(
    async e => {
      const file = e.target.files?.[0];
      if (file) {
        const src = await uploadService(file);
        editor.chain().focus().setImage({ src }).run();
      }
    },
    [editor, uploadService]
  );

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept="image/png, image/jpeg"
        onChange={onSelectFile}
        style={{ opacity: 0, width: 0, overflow: 'hidden' }}
      />
      <ToolbarButton onClick={onClick}>{children}</ToolbarButton>
    </>
  );
};
